export type PiletPermissions = {
    hasToolsAccess: boolean;
};

const defaultPiletPermissions: PiletPermissions = {
    hasToolsAccess: false,
};

export const getPilets = (
    piletStr: string,
    piletPermissions: PiletPermissions = defaultPiletPermissions,
): { name: string }[] => {
    if (piletStr) {
        // loop through the array to create the object
        // sample: ?pilets=case-inventory-pilet,case-overview-pilet,case-audit-log-ui
        return piletStr.split(",").map((name) => ({ name }));
    }
    const piletsToLoad: { name: string }[] = [
        // e.g.:
        { name: "ccap-umds-ui" },
        { name: "ccap-ui-epv-investigation-case-pilet" },
        { name: "ccap-ui-investigation-case-list-pilet" },
        { name: "ccap-ui-investigation-pilet" },
    ];

    if (piletPermissions.hasToolsAccess) {
        piletsToLoad.push({ name: "ccap-ui-admin-pilet" });
    }

    return piletsToLoad;
};

export const getIdpPathParam = () => {
    const pathname = window.location.pathname;
    const pathSegments = pathname.split("/");
    if (pathSegments.length > 2 && pathSegments[1] === "sso") {
        return pathSegments[2];
    }
};
